import { AdminUserFilters, AdminUserPage } from "../types/adminUser.definition";
import { disableUser, searchAdminUsers } from "../webclients/adminUser.client";
import { reactivateUser, verifyUser } from "../webclients/user.client";

/** MED-1341: account directory behind the Utilisateurs page and the new sign-ups on Aperçu. */
export const adminUsersApi = {
  search: async (
    filters: AdminUserFilters,
    page: number,
    size: number
  ): Promise<AdminUserPage> => {
    const response = await searchAdminUsers(filters, page, size);
    return response.data;
  },

  disable: async (id: number): Promise<void> => {
    await disableUser(id);
  },

  enable: async (id: number): Promise<void> => {
    await reactivateUser(id);
  },

  verify: async (id: number): Promise<void> => {
    await verifyUser(id);
  },
};
